<template>
    <router-link :to="{name: route ,params: { id: extraValues.opdracht_id }, query: { assigment:  extraValues.assignment_id ? extraValues.assignment_id : 'applicant' }}" class="c-btn c-btn--tiny c-btn--secondary no-margin">Bekijken</router-link>
</template>

<script>
import Column from '@mixins/Column';

export default {
    mixins: [ Column ],
    props: {
        route: {
            type: String,
            required: true
        },
        extraValues: {
            type: Object,
            required: false,
            default: () => {}
        }
    }
}
</script>
